import React, {useState} from 'react';

import {Button, Input, JournalIcon, LevelUpIcon, LongRestIcon, ShortRestIcon, WrenchIcon} from '@kit';

import {useCharacter} from '../character-context';
import {MAX_CHARACTER_LEVEL} from '../model/character-state';
import {ExperienceButton} from './experience-button';
import {JournalModal} from './journal-modal';
import {LevelUpModal} from './level-up-modal';
import {LongRestModal, ShortRestModal} from './rest-modals';
import {useWideScreen} from './use-wide-screen';

import css from './sheet.module.css';

type HeaderModal = 'levelUp' | 'shortRest' | 'longRest' | 'journal';

type Props = {
	/** открыть конструктор с текущими выборами */
	onOpenConstructor(): void;
};

export const SheetHeader: React.FC<Props> = ({onOpenConstructor}) => {
	const {catalog, state, character, update} = useCharacter();
	const [openedModal, setOpenedModal] = useState<HeaderModal | null>(null);
	const specie = state.specieId ? catalog.getSpecie(state.specieId) : undefined;
	const close = () => setOpenedModal(null);

	const classesText = character.classes
		.map(({classData, level, subClass}) => `${classData.title}${subClass ? ` (${subClass.title})` : ''} ${level}`)
		.join(' / ');
	const summary = [specie?.title, classesText].filter(Boolean);
	const isWide = useWideScreen();

	const buttons = [
		character.level < MAX_CHARACTER_LEVEL && {
			title: 'Повысить уровень',
			icon: <LevelUpIcon />,
			primary: true,
			onClick: () => setOpenedModal('levelUp'),
		},
		{title: 'Короткий отдых', icon: <ShortRestIcon />, onClick: () => setOpenedModal('shortRest')},
		{title: 'Долгий отдых', icon: <LongRestIcon />, onClick: () => setOpenedModal('longRest')},
		{title: 'Конструктор', icon: <WrenchIcon />, onClick: onOpenConstructor},
		{title: 'Журнал действий', icon: <JournalIcon />, onClick: () => setOpenedModal('journal')},
	].filter(Boolean) as {title: string; icon: React.ReactNode; primary?: boolean; onClick(): void}[];

	return (
		<header className={css.header}>
			<div className={css.headerTitle}>
				<Input
					className={css.nameInput}
					appearance="underline"
					size="large"
					placeholder="Имя персонажа"
					value={state.name}
					onChange={(name) => update({name: String(name ?? '')})}
				/>
				<div className={css.headerSummary}>
					{summary.map((part) => (
						<span key={part}>{part}</span>
					))}
					<ExperienceButton />
				</div>
			</div>
			<div className={css.headerButtons}>
				{buttons.map(({title, icon, primary, onClick}) => (
					<Button
						key={title}
						appearance={primary ? 'primary' : 'secondary'}
						icon={icon}
						title={isWide ? undefined : title}
						aria-label={isWide ? undefined : title}
						onClick={onClick}
					>
						{isWide && title}
					</Button>
				))}
			</div>
			{openedModal === 'levelUp' && <LevelUpModal onClose={close} />}
			{openedModal === 'shortRest' && <ShortRestModal onClose={close} />}
			{openedModal === 'longRest' && <LongRestModal onClose={close} />}
			<JournalModal open={openedModal === 'journal'} onClose={close} />
		</header>
	);
};
